
import apiRequest from "../api/api-request";

const authService = {
  getProperty: async (propertyId, oProperty) => {
    return apiRequest({
      method: 'GET',
      url: `/api/v1/property-review/property/${propertyId}`,
      data: oProperty,
      headers: {
        'X-Token': process.env.REACT_APP_X_Token
      }
    });
  },

  submitReview: async (tData) => {
    return apiRequest({
      method: "POST",
      url: "/api/v1/property-review/submitReview",
      data: tData,
      headers: {
        'X-Token': process.env.REACT_APP_X_Token
      },
    });
  },

  trackRating: async (tData) => {
    return apiRequest({
      method: "POST",
      url: "/api/v1/property-review/trackRating",
      data: tData,
      headers: {
        'X-Token': process.env.REACT_APP_X_Token
      },
    });
  },

};

export default authService;

